export const proveedoresSancionadosData = [
  {
    "numero": 1,
    "nivel": "Estatal",
    "proveedorContratista": "Construcciones Y Renta De Maquinaria Ivaco, Sociedad Anónima de Capital Variable (CONTRATISTA)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "3505",
    "sentidoResolucion": "Cancelación de registro por 6 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/construcciones_ivaco.pdf"
  },
  {
    "numero": 2,
    "nivel": "Estatal",
    "proveedorContratista": "Ramón Velasco Álvarez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "013-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercio_farmaceuticos.pdf"
  },
  {
    "numero": 3,
    "nivel": "Estatal",
    "proveedorContratista": "Bullet México, Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "159-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/bullet_mexico.pdf"
  },
  {
    "numero": 4,
    "nivel": "Estatal",
    "proveedorContratista": "Consorcio Carretero Lanus Fayen, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1164-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/lanus_fayen.pdf"
  },
  {
    "numero": 5,
    "nivel": "Estatal",
    "proveedorContratista": "Denisse del Jazmín Hernández Hernández (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "479-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/jazmin_hernandez.pdf"
  },
  {
    "numero": 6,
    "nivel": "Estatal",
    "proveedorContratista": "Desarrollo Carretero Hidalguense, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "018-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/carretero_hidalguense.pdf"
  },
  {
    "numero": 7,
    "nivel": "Estatal",
    "proveedorContratista": "Deyra Ramírez Fernández (PROVEEDO",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "329-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/deyra_ramirez.pdf"
  },
  {
    "numero": 8,
    "nivel": "Estatal",
    "proveedorContratista": "Edgar Clemente Aguirre (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "623-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/edgar_clemente.pdf"
  },
  {
    "numero": 9,
    "nivel": "Estatal",
    "proveedorContratista": "Eucario Jiménez Calva (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "571-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/eucario_jimenez.pdf"
  },
  {
    "numero": 10,
    "nivel": "Estatal",
    "proveedorContratista": "Generando Innovaciones Médicas Saem, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "355-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/medicas_saem.pdf"
  },
  {
    "numero": 11,
    "nivel": "Estatal",
    "proveedorContratista": "GS Suministros y Servicios TI, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1160-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/gs_suministros.pdf"
  },
  {
    "numero": 12,
    "nivel": "Estatal",
    "proveedorContratista": "Interdisplay México, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "099-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/Interdisplay_mexico.pdf"
  },
  {
    "numero": 13,
    "nivel": "Estatal",
    "proveedorContratista": "Juan Antonio Soto del Hoyo (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "186-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/juan_del_hoyo.pdf"
  },
  {
    "numero": 14,
    "nivel": "Estatal",
    "proveedorContratista": "Juan Jesús Pacheco Santos (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "153-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/pacheco_santos.pdf"
  },
  {
    "numero": 15,
    "nivel": "Estatal",
    "proveedorContratista": "Karla Isela Aguirre Oropeza (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1179-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/isela_oropeza.pdf"
  },
  {
    "numero": 16,
    "nivel": "Estatal",
    "proveedorContratista": "Limpia Tec, Sociedad Anónima de Capital Variable (PROVEEDOR",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "521-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/limpia_sociedad.pdf"
  },
  {
    "numero": 17,
    "nivel": "Estatal",
    "proveedorContratista": "Menrui Construcciones y Proyectos, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "027-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/menrui_construcciones.pdf"
  },
  {
    "numero": 18,
    "nivel": "Estatal",
    "proveedorContratista": "Moisés Alberto Sánchez Mendoza (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "150-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/moises_sanchez.pdf"
  },
  {
    "numero": 19,
    "nivel": "Estatal",
    "proveedorContratista": "Nereida Viridiana Vázquez Juárez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "143-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/nereida_juarez.pdf"
  },
  {
    "numero": 20,
    "nivel": "Estatal",
    "proveedorContratista": "Protección Secsa, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "738-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/servicios_secsa.pdf"
  },
  {
    "numero": 21,
    "nivel": "Estatal",
    "proveedorContratista": "RAR Computación, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1144-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/rar_computacion.pdf"
  },
  {
    "numero": 22,
    "nivel": "Estatal",
    "proveedorContratista": "TRIP CT, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "733-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/trip_ct.pdf"
  },
  {
    "numero": 23,
    "nivel": "Estatal",
    "proveedorContratista": "Víctor Manuel Martínez Quezada (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "203-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/martinez_quezada.pdf"
  },
  {
    "numero": 24,
    "nivel": "Estatal",
    "proveedorContratista": "Victoria Jaqueline Mendoza Zamora (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "288-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/victoria_zamora.pdf"
  },
  {
    "numero": 25,
    "nivel": "Estatal",
    "proveedorContratista": "Telesinergia, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "791-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/telesinergia_sociedad.pdf"
  },
  {
    "numero": 26,
    "nivel": "Estatal",
    "proveedorContratista": "Flor Piña Hernández (PRéVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "272-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/flor_pina.pdf"
  },
  {
    "numero": 27,
    "nivel": "Estatal",
    "proveedorContratista": "Control de Plagas Profesionales, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "823-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/control_plagas.pdf"
  },
  {
    "numero": 28,
    "nivel": "Estatal",
    "proveedorContratista": "Security Private Tecno Lion de Hidalgo, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "426-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/anselmo_garcia.pdf"
  },
  {
    "numero": 29,
    "nivel": "Estatal",
    "proveedorContratista": "El Quinto Sol Arte en Movimiento, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "946-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/quinto_sol.pdf"
  },
  {
    "numero": 30,
    "nivel": "Estatal",
    "proveedorContratista": "Naivi Ramírez Clemente (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "532-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/naivi_ramirez.pdf"
  },
  {
    "numero": 31,
    "nivel": "Estatal",
    "proveedorContratista": "Sabina López Gutiérrez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "030-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/sabina_lopez.pdf"
  },
  {
    "numero": 32,
    "nivel": "Estatal",
    "proveedorContratista": "Mauricio Montes Dorante (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "353-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/mauricio_dorante.pdf"
  },
  {
    "numero": 33,
    "nivel": "Estatal",
    "proveedorContratista": "María Guadalupe Lazcano Fragoso (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "469-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/maria_lazcano.pdf"
  },
  {
    "numero": 34,
    "nivel": "Estatal",
    "proveedorContratista": "María Guadalupe Hernández Islés (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "190-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/gpe_hdez_islas.pdf"
  },
  {
    "numero": 35,
    "nivel": "Estatal",
    "proveedorContratista": "Sergio Carpio Alarcón (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "140-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/sergio_carpio.pdf"
  },
  {
    "numero": 36,
    "nivel": "Estatal",
    "proveedorContratista": "Juan García Franco (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "496-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/juan_franco.pdf"
  },
  {
    "numero": 37,
    "nivel": "Estatal",
    "proveedorContratista": "More Than Ice Entertaimet, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "620-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/more_than.pdf"
  },
  {
    "numero": 38,
    "nivel": "Estatal",
    "proveedorContratista": "Industrial Universal Didáctica, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "108-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/universal_didactica.pdf"
  },
  {
    "numero": 39,
    "nivel": "Estatal",
    "proveedorContratista": "Multiservicios Corporativos MM, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1191-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/multiservicios_corporativos.pdf"
  },
  {
    "numero": 40,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Constructor Copan, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1050-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/grupo_copan.pdf"
  },
  {
    "numero": 41,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora FET, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "450-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercializadora_fet.pdf"
  },
  {
    "numero": 42,
    "nivel": "Estatal",
    "proveedorContratista": "Lyem Seguridad Pública, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "218-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/lyem_seguridad.pdf"
  },
  {
    "numero": 43,
    "nivel": "Estatal",
    "proveedorContratista": "Blanca Osbelia Hernández Jiménez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "072-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/blanca_osbelia.pdf"
  },
  {
    "numero": 44,
    "nivel": "Estatal",
    "proveedorContratista": "COSAPI Constructora, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "002-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/cosapi_constructora.pdf"
  },
  {
    "numero": 45,
    "nivel": "Estatal",
    "proveedorContratista": "Eventos Especiales Rugles, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "490-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/eventos_rugles.pdf"
  },
  {
    "numero": 46,
    "nivel": "Estatal",
    "proveedorContratista": "Proveedora R.M., Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "319-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/proveedora_rm.pdf"
  },
  {
    "numero": 47,
    "nivel": "Estatal",
    "proveedorContratista": "Profesionistas en Mercadotecnia del Bajío, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "439-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/profesionistas_mercadotecnia.pdf"
  },
  {
    "numero": 48,
    "nivel": "Estatal",
    "proveedorContratista": "Martha Valeria Aguirre Cerrilla (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "237-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/martha_cerrilla.pdf"
  },
  {
    "numero": 49,
    "nivel": "Estatal",
    "proveedorContratista": "Cosmocolor, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "180-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/cosmocolor_sociedad.pdf"
  },
  {
    "numero": 50,
    "nivel": "Estatal",
    "proveedorContratista": "GEGR, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "541-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/gegr_sociedad.pdf"
  },
  {
    "numero": 51,
    "nivel": "Estatal",
    "proveedorContratista": "Giovanna Saldaña Morales (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "176-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/giovanna_saldana.pdf"
  },
  {
    "numero": 52,
    "nivel": "Estatal",
    "proveedorContratista": "Arturo Zaharí García (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "249-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/arturo_zahar.pdf"
  },
  {
    "numero": 53,
    "nivel": "Estatal",
    "proveedorContratista": "Germán Carrillo Criner (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "329-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/german_criner.pdf"
  },
  {
    "numero": 54,
    "nivel": "Estatal",
    "proveedorContratista": "Leticia Calderón Acosta (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "454-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/leti_calderon.pdf"
  },
  {
    "numero": 55,
    "nivel": "Estatal",
    "proveedorContratista": "Clara Patricia Pacheco Cázares (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "574-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/clara_cazares.pdf"
  },
  {
    "numero": 56,
    "nivel": "Estatal",
    "proveedorContratista": "César Reyes Hernández (éROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "201-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/cesar_reyes.pdf"
  },
  {
    "numero": 57,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Empresarial Dzmundy, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1174-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/grupo_dzmundy.pdf"
  },
  {
    "numero": 58,
    "nivel": "Estatal",
    "proveedorContratista": "José Francisco Villeda Velázquez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "154-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/jose_villeda.pdf"
  },
  {
    "numero": 59,
    "nivel": "Estatal",
    "proveedorContratista": "Mara Lizeth Torres Alonso (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "294-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/mara_torres.pdf"
  },
  {
    "numero": 60,
    "nivel": "Estatal",
    "proveedorContratista": "César Adrián De Luna Castañeda (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "333-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/cesar_casta%C3%B1eda.pdf"
  },
  {
    "numero": 61,
    "nivel": "Estatal",
    "proveedorContratista": "Paradigma Noticias, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "147-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/paradigma_noticias.pdf"
  },
  {
    "numero": 62,
    "nivel": "Estatal",
    "proveedorContratista": "Inmobiliaria Real del Paraíso, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "249-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/inmobiliaria_paraiso.pdf"
  },
  {
    "numero": 63,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Constructor Gelzen, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "232-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/grupo_gelzen.pdf"
  },
  {
    "numero": 64,
    "nivel": "Estatal",
    "proveedorContratista": "Daparo, Sociedad de Responsabilidad Limitada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "142-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/daparo_sociedad.pdf"
  },
  {
    "numero": 65,
    "nivel": "Estatal",
    "proveedorContratista": "Fredy Escalera Cortés (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "639-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/fredy_escalera.pdf"
  },
  {
    "numero": 66,
    "nivel": "Estatal",
    "proveedorContratista": "Rafael Ricardo OlveraíGarcía (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "362-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/rafael_olvera.pdf"
  },
  {
    "numero": 67,
    "nivel": "Estatal",
    "proveedorContratista": "Emi Consulting & Ti, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "614-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/emi_consulting.pdf"
  },
  {
    "numero": 68,
    "nivel": "Estatal",
    "proveedorContratista": "Ernesto Ignacio Sánchez Hernández (PRéVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "096-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/ernesto_sanchez.pdf"
  },
  {
    "numero": 69,
    "nivel": "Estatal",
    "proveedorContratista": "Qiacso, Sociedad de Responsabilidad Limitada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "460-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/qiacso_sociedad.pdf"
  },
  {
    "numero": 70,
    "nivel": "Estatal",
    "proveedorContratista": "Arturo LunaíGarcía (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "257-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/arturo_luna.pdf"
  },
  {
    "numero": 71,
    "nivel": "Estatal",
    "proveedorContratista": "Vanessa Ivonne Ortega Meneses (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "502-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/vanesa_ortega.pdf"
  },
  {
    "numero": 72,
    "nivel": "Estatal",
    "proveedorContratista": "Claudia Contreras Zamora (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "273-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/claudia_contreras.pdf"
  },
  {
    "numero": 73,
    "nivel": "Estatal",
    "proveedorContratista": "Kasvu Soluciones, Sociedad de Responsabilidad Limitada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "249-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/kasvu_soluciones.pdf"
  },
  {
    "numero": 74,
    "nivel": "Estatal",
    "proveedorContratista": "Constru Mantenimiento y Servicio Nivel 3, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "019-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/constru_mantenimiento.pdf"
  },
  {
    "numero": 75,
    "nivel": "Estatal",
    "proveedorContratista": "Suministros y Servicios Comerciales Ulloa, Sociedad de Responsabilidad Limitada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "018-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/suministros_ulloa.pdf"
  },
  {
    "numero": 76,
    "nivel": "Estatal",
    "proveedorContratista": "Daniel Castañeda Huijón (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "292-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/daniel_casta%C3%B1eda.pdf"
  },
  {
    "numero": 77,
    "nivel": "Estatal",
    "proveedorContratista": "Arnaldo Cobo Hernández (éROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "022-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/arnaldo_cobo.pdf"
  },
  {
    "numero": 78,
    "nivel": "Estatal",
    "proveedorContratista": "Luz María Guadalupe Palafox Lozano (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "179-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/luz_palafox.pdf"
  },
  {
    "numero": 79,
    "nivel": "Estatal",
    "proveedorContratista": "Insumos y Materiales para el Desarrollo Social, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "755-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/insumos_materiales.pdf"
  },
  {
    "numero": 80,
    "nivel": "Estatal",
    "proveedorContratista": "Francisco Bernardo Cuvas Ortiz (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "638-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/francisco_cuvas.pdf"
  },
  {
    "numero": 81,
    "nivel": "Estatal",
    "proveedorContratista": "Iram Jiménez Galicia (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "013-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/iram_jimenez.pdf"
  },
  {
    "numero": 82,
    "nivel": "Estatal",
    "proveedorContratista": "Héctor Alonso Cruz Micette (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "447-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/hector_cruz.pdf"
  },
  {
    "numero": 83,
    "nivel": "Estatal",
    "proveedorContratista": "María De Lourdes Zamora Hurtado (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "287-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/maria_zamora.pdf"
  },
  {
    "numero": 84,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Alatorre Juárez Y Asociados, Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "058-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercializadora_alatorre.pdf"
  },
  {
    "numero": 85,
    "nivel": "Estatal",
    "proveedorContratista": "Roberto Mendoza Baylon (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "459-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/roberto_mendoza.pdf"
  },
  {
    "numero": 86,
    "nivel": "Estatal",
    "proveedorContratista": "María Celsa Martha Ramírez Vargas (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "361-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/maria_celsa.pdf"
  },
  {
    "numero": 87,
    "nivel": "Estatal",
    "proveedorContratista": "Miriam Calva Hernández (éROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1151-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/miriam_calva.pdf"
  },
  {
    "numero": 88,
    "nivel": "Estatal",
    "proveedorContratista": "Comercio Informático De Hidalgo, Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "835-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercio_informatico.pdf"
  },
  {
    "numero": 89,
    "nivel": "Estatal",
    "proveedorContratista": "Corporativo Mucom, Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "584-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/corporativo_mucom.pdf"
  },
  {
    "numero": 90,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Constructor Logarsa, Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "491-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/grupo_logarsa.pdf"
  },
  {
    "numero": 91,
    "nivel": "Estatal",
    "proveedorContratista": "Rosalío Mendoza Sánchez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "245-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/rosalio_mendoza.pdf"
  },
  {
    "numero": 92,
    "nivel": "Estatal",
    "proveedorContratista": "Gilberto Amilcar Alamilla Hernández (PRéVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "549-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/gilberto_alamilla.pdf"
  },
  {
    "numero": 93,
    "nivel": "Estatal",
    "proveedorContratista": "Fernando Soto Casasola (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "127-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/fernando_soto.pdf"
  },
  {
    "numero": 94,
    "nivel": "Estatal",
    "proveedorContratista": "María Guadalupe Alanís Espinosa (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "351-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/maria_alanis.pdf"
  },
  {
    "numero": 95,
    "nivel": "Estatal",
    "proveedorContratista": "Verónica Vázquez Ortiz (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "128-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/veronica_vazquez.pdf"
  },
  {
    "numero": 96,
    "nivel": "Estatal",
    "proveedorContratista": "Claudia Cruz Barragán (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "367-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/claudia_cruz.pdf"
  },
  {
    "numero": 97,
    "nivel": "Estatal",
    "proveedorContratista": "María Esperanza Escobedo Silva (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "173-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/maria_escobedo.pdf"
  },
  {
    "numero": 98,
    "nivel": "Estatal",
    "proveedorContratista": "Fernando Vinicio Roldán Mendoza (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "143-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/fernando_roldan.pdf"
  },
  {
    "numero": 99,
    "nivel": "Estatal",
    "proveedorContratista": "Anabel López León (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "338-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/anabel_lopez.pdf"
  },
  {
    "numero": 100,
    "nivel": "Estatal",
    "proveedorContratista": "Gabriela Rello Ruíz (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "360-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/gabriela_rello.pdf"
  },
  {
    "numero": 101,
    "nivel": "Estatal",
    "proveedorContratista": "Rubén Correa Morán (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "250-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/ruben_correa.pdf"
  },
  {
    "numero": 102,
    "nivel": "Estatal",
    "proveedorContratista": "María Concepción Castro Jiménez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "236-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/maria_castro.pdf"
  },
  {
    "numero": 103,
    "nivel": "Estatal",
    "proveedorContratista": "José De Jesús Gutiérrez Cruz (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "362-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/jesus_gutierrez.pdf"
  },
  {
    "numero": 104,
    "nivel": "Estatal",
    "proveedorContratista": "Juan Carlos Del Castillo Jiménez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "450-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/carlos_del%20castillo.pdf"
  },
  {
    "numero": 105,
    "nivel": "Estatal",
    "proveedorContratista": "Ma. Guadalupe Amezcua Cortez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "470-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/ma_amezcua.pdf"
  },
  {
    "numero": 106,
    "nivel": "Estatal",
    "proveedorContratista": "Samuel Hernández Maréínez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "553-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/samuel_hernandez.pdf"
  },
  {
    "numero": 107,
    "nivel": "Estatal",
    "proveedorContratista": "Ana MaríaíGarcía Fonseca (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "194-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/ana_garcia.pdf"
  },
  {
    "numero": 108,
    "nivel": "Estatal",
    "proveedorContratista": "Estefany León Sánchez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "102-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/estefany_leon.pdf"
  },
  {
    "numero": 109,
    "nivel": "Estatal",
    "proveedorContratista": "Gerardo Islas Franco (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "063-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/gerardo_islas.pdf"
  },
  {
    "numero": 110,
    "nivel": "Estatal",
    "proveedorContratista": "José Arturo Meneses Fosado (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "623-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/jose_meneses.pdf"
  },
  {
    "numero": 111,
    "nivel": "Estatal",
    "proveedorContratista": "Enrique López Ibarra (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1152-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/enrique_lopez.pdf"
  },
  {
    "numero": 112,
    "nivel": "Estatal",
    "proveedorContratista": "Ana Daniela Violante Chávez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "927-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/ana_violante.pdf"
  },
  {
    "numero": 113,
    "nivel": "Estatal",
    "proveedorContratista": "Rebeca Peralta González (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "889-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/rebeca_peralta.pdf"
  },
  {
    "numero": 114,
    "nivel": "Estatal",
    "proveedorContratista": "Habid José Luis Altamira Rodríguez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "763-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/habid_altamira.pdf"
  },
  {
    "numero": 115,
    "nivel": "Estatal",
    "proveedorContratista": "Joaquín Ramírez Rodríguez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1141-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/joaquin_ramirez.pdf"
  },
  {
    "numero": 116,
    "nivel": "Estatal",
    "proveedorContratista": "Alejandro Monroy Trejo (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "452-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/alejandro_monroy.pdf"
  },
  {
    "numero": 117,
    "nivel": "Estatal",
    "proveedorContratista": "Ana Lidia Silva Meneses (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "551-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/ana_silva.pdf"
  },
  {
    "numero": 118,
    "nivel": "Estatal",
    "proveedorContratista": "Elizabeth Lucía ArteagaíGarcía (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1077-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/elizabeth_arteaga.pdf"
  },
  {
    "numero": 119,
    "nivel": "Estatal",
    "proveedorContratista": "Jocelyn Traspeña López (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1171-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/jocelyn_traspe%C3%B1a.pdf"
  },
  {
    "numero": 120,
    "nivel": "Estatal",
    "proveedorContratista": "María De Lourdes Martínez Cervantes (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "113-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/maria_martinez.pdf"
  },
  {
    "numero": 121,
    "nivel": "Estatal",
    "proveedorContratista": "Gerardo Eugenio Alvarado Hierro (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1117-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/gerardo_alvarado.pdf"
  },
  {
    "numero": 122,
    "nivel": "Estatal",
    "proveedorContratista": "Alberto César Flores Mandujano (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "373-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/alberto_flores.pdf"
  },
  {
    "numero": 123,
    "nivel": "Estatal",
    "proveedorContratista": "Nayeli Jaqueline Pérez Aguirre (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "423-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/nayeli_perez.pdf"
  },
  {
    "numero": 124,
    "nivel": "Estatal",
    "proveedorContratista": "Liliana Samperio Zaldívar (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "233-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/liliana_samperio.pdf"
  },
  {
    "numero": 125,
    "nivel": "Estatal",
    "proveedorContratista": "Mario Luis Zacatenco Viornery (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "155-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/mario_zacatenco.pdf"
  },
  {
    "numero": 126,
    "nivel": "Estatal",
    "proveedorContratista": "YagelíGarcía Caballero (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "174-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/yagel_garcia.pdf"
  },
  {
    "numero": 127,
    "nivel": "Estatal",
    "proveedorContratista": "Guadalupe Reyes Jacome (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "142-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/guadalupe_reyes.pdf"
  },
  {
    "numero": 128,
    "nivel": "Estatal",
    "proveedorContratista": "Adela Cobos Cobos (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "175-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/adela_cobos.pdf"
  },
  {
    "numero": 129,
    "nivel": "Estatal",
    "proveedorContratista": "Néstor Lozano Chávez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "134-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/nestor_lozano.pdf"
  },
  {
    "numero": 130,
    "nivel": "Estatal",
    "proveedorContratista": "Raquel Pastor Medina (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "315-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/raquel_pastor.pdf"
  },
  {
    "numero": 131,
    "nivel": "Estatal",
    "proveedorContratista": "Juan Carlos Peña Sánchez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "308-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/juan_pe%C3%B1a.pdf"
  },
  {
    "numero": 132,
    "nivel": "Estatal",
    "proveedorContratista": "Alicia Zamora Reyes (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "388-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/alicia_zamora.pdf"
  },
  {
    "numero": 133,
    "nivel": "Estatal",
    "proveedorContratista": "Bruno Pastor Medina (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "311-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/bruno_pastor.pdf"
  },
  {
    "numero": 134,
    "nivel": "Estatal",
    "proveedorContratista": "Rocío Janette Morgan Franco (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "318-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/rocio_morgan.pdf"
  },
  {
    "numero": 135,
    "nivel": "Estatal",
    "proveedorContratista": "Lidia Hernández Vaqéero (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "312-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/lidia_hernandez.pdf"
  },
  {
    "numero": 136,
    "nivel": "Estatal",
    "proveedorContratista": "Mario Eduardo QuebedoíGarcía (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "520-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/mario_quebedo.pdf"
  },
  {
    "numero": 137,
    "nivel": "Estatal",
    "proveedorContratista": "David OlveraíGarcía (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "529-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/david_olvera.pdf"
  },
  {
    "numero": 138,
    "nivel": "Estatal",
    "proveedorContratista": "Enrique González Campero (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "509-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/enrique_gonzalez.pdf"
  },
  {
    "numero": 139,
    "nivel": "Estatal",
    "proveedorContratista": "Donato Iván Alor Carrasco (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "464-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/donato_alor.pdf"
  },
  {
    "numero": 140,
    "nivel": "Estatal",
    "proveedorContratista": "MLM Tecnología Y Construcción, Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "388-16",
    "sentidoResolucion": "Suspensión de registro por 2 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/mlm_tecnologia.pdf"
  },
  {
    "numero": 141,
    "nivel": "Estatal",
    "proveedorContratista": "Construcciones Gómez Sanroman, Sociedad Anónima de Capital Variable (CONTRATISTA)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "011-20",
    "sentidoResolucion": "Cancelación de registro por 6 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/construcciones_gomez.pdf"
  },
  {
    "numero": 142,
    "nivel": "Estatal",
    "proveedorContratista": "José Manuel Torrez España (CONTRATISTA)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "3821-14",
    "sentidoResolucion": "Cancelación de registro por 6 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/jose_torrez.pdf"
  },
  {
    "numero": 143,
    "nivel": "Estatal",
    "proveedorContratista": "Albertino Ledezma Illescas (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "627-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/albertino_ledezma.pdf"
  },
  {
    "numero": 144,
    "nivel": "Estatal",
    "proveedorContratista": "Luis AlbertoíGarcía Cárdenas (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "637-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/luis_alberto.pdf"
  },
  {
    "numero": 145,
    "nivel": "Estatal",
    "proveedorContratista": "ArmandoíGarcía Cortés (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "642-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/armando_garcia.pdf"
  },
  {
    "numero": 146,
    "nivel": "Estatal",
    "proveedorContratista": "Malintzin González Solís (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "665-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/malitzin_gonzalez.pdf"
  },
  {
    "numero": 147,
    "nivel": "Estatal",
    "proveedorContratista": "Milton Romero Espinoza (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "776-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/milton_romero.pdf"
  },
  {
    "numero": 148,
    "nivel": "Estatal",
    "proveedorContratista": "Mirel CastellíGarcía (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "062-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/mirel_castell.pdf"
  },
  {
    "numero": 149,
    "nivel": "Estatal",
    "proveedorContratista": "Christian Cortés Reyes (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "601-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/cristian_cortes.pdf"
  },
  {
    "numero": 150,
    "nivel": "Estatal",
    "proveedorContratista": "Erik Hernández Gutiérrez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "671-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/erik_hernandez.pdf"
  },
  {
    "numero": 151,
    "nivel": "Estatal",
    "proveedorContratista": "Adrián Rangel Ciprés (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "563-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/adrian_rangel.pdf"
  },
  {
    "numero": 152,
    "nivel": "Estatal",
    "proveedorContratista": "Gustavo Said González Tapia (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "175-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/gustavo_said.pdf"
  },
  {
    "numero": 153,
    "nivel": "Estatal",
    "proveedorContratista": "Javier López Torres (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "137-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/javier_lopez.pdf"
  },
  {
    "numero": 154,
    "nivel": "Estatal",
    "proveedorContratista": "Hilda Mejía Trejo (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "765-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/hilda_mejia.pdf"
  },
  {
    "numero": 155,
    "nivel": "Estatal",
    "proveedorContratista": "Servicios Logísticos Y Energéticos Del Centro Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "048-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/servicios_logisticos.pdf"
  },
  {
    "numero": 156,
    "nivel": "Estatal",
    "proveedorContratista": "Promotora Don Mostacho, Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "564-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/promotora_mostacho.pdf"
  },
  {
    "numero": 157,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Hikoa, Sociedad de Responsabilidad Limitada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "048-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercializadora_hikoa.pdf"
  },
  {
    "numero": 158,
    "nivel": "Estatal",
    "proveedorContratista": "Fareel De Hidalgo, Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "045-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/fareel_hidalgo.pdf"
  },
  {
    "numero": 159,
    "nivel": "Estatal",
    "proveedorContratista": "Hersai, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "105-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/hersai_sociedad.pdf"
  },
  {
    "numero": 160,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora de Tecnologías y Uniformes Especializados Sec, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "132-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercializadora_tecnologias.pdf"
  },
  {
    "numero": 161,
    "nivel": "Estatal",
    "proveedorContratista": "Masterval, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "204-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/masterval_sociedad.pdf"
  },
  {
    "numero": 162,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Noaide, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "323-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/grupo_noaide.pdf"
  },
  {
    "numero": 163,
    "nivel": "Estatal",
    "proveedorContratista": "Sistemas, Equipamiento E Implementos Técnicos San Javier, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "319-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/sistemas_equipamiento.pdf"
  },
  {
    "numero": 164,
    "nivel": "Estatal",
    "proveedorContratista": "Eléctrica Barba, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "302-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/electrica_barba.pdf"
  },
  {
    "numero": 165,
    "nivel": "Estatal",
    "proveedorContratista": "Igma Network Business Tic-Si, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "337-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/igma_network.pdf"
  },
  {
    "numero": 166,
    "nivel": "Estatal",
    "proveedorContratista": "Especialistas En Imagen Pública, Sociedad Anónima De Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "288-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/especialistas_imagen.pdf"
  },
  {
    "numero": 167,
    "nivel": "Estatal",
    "proveedorContratista": "Alug Comercializadora, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "309-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/alug_comercializadora.pdf"
  },
  {
    "numero": 168,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Grecsa, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "465-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/grupo_grecsa.pdf"
  },
  {
    "numero": 169,
    "nivel": "Estatal",
    "proveedorContratista": "Luacsa Motors de México, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "462-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/luacsa_motors.pdf"
  },
  {
    "numero": 170,
    "nivel": "Estatal",
    "proveedorContratista": "Reactívate Administración Integral y Consultoría, Sociedad Civil (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "499-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/reactivate_administracion.pdf"
  },
  {
    "numero": 171,
    "nivel": "Estatal",
    "proveedorContratista": "Cinme, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "456-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/cinme_sociedad.pdf"
  },
  {
    "numero": 172,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Microlim, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "476-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercializadora_microlim.pdf"
  },
  {
    "numero": 173,
    "nivel": "Estatal",
    "proveedorContratista": "Autopharma, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "662-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/autopharma_sociedad.pdf"
  },
  {
    "numero": 174,
    "nivel": "Estatal",
    "proveedorContratista": "Sitecsa de Hidalgo, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "621-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/sitecsa_hidalgo.pdf"
  },
  {
    "numero": 175,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Biznesi, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "706-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercializadora_biznesi.pdf"
  },
  {
    "numero": 176,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Hmj, Sociedad de Responsabilidad Limitada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "741-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercializadora_hmj.pdf"
  },
  {
    "numero": 177,
    "nivel": "Estatal",
    "proveedorContratista": "Despacho Auditor Fiscal Okali, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "778-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/despacho_auditor.pdf"
  },
  {
    "numero": 178,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Moracsa, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "973-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/comercializadora_moracsa.pdf"
  },
  {
    "numero": 179,
    "nivel": "Estatal",
    "proveedorContratista": "Import & Export Canamexi, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1033-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/import_export.pdf"
  },
  {
    "numero": 180,
    "nivel": "Estatal",
    "proveedorContratista": "Hope Mexicana De Negocios, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1134-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/hope_mexicana.pdf"
  },
  {
    "numero": 181,
    "nivel": "Estatal",
    "proveedorContratista": "Proyectos Estratégicos Consultoría, Sociedad Civil (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "031-10-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/proyectos_estrategicos.pdf"
  },
  {
    "numero": 182,
    "nivel": "Estatal",
    "proveedorContratista": "Alta Cocina de Pachuca, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1099-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/alta_cocina.pdf"
  },
  {
    "numero": 183,
    "nivel": "Estatal",
    "proveedorContratista": "Productora Agropecuaria Neek, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "049-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/productora_agropecuaria.pdf"
  },
  {
    "numero": 184,
    "nivel": "Estatal",
    "proveedorContratista": "Constru Oro, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "224-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/constru_oro.pdf"
  },
  {
    "numero": 185,
    "nivel": "Estatal",
    "proveedorContratista": "Congenycom, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "292-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/congenycom_sociedad.pdf"
  },
  {
    "numero": 186,
    "nivel": "Estatal",
    "proveedorContratista": "Sinntec Innovación Tecnológica, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "316-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/sinntec_innovacion.pdf"
  },
  {
    "numero": 187,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Lozada, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "473-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1wOSw86O7VDaSiWckoWuYRp3zVTWmt0LY/view?usp=share_link"
  },
  {
    "numero": 188,
    "nivel": "Estatal",
    "proveedorContratista": "Desarrollo G57, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "613-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/14fxpn4KvtRFFWFyiCWSGoRWquUiBD7f3/view?usp=share_link"
  },
  {
    "numero": 189,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Comercializador Celiv, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "592-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1LpYPLNRoZ6kSDKS225jKNxDu53Pegu43/view?usp=share_link"
  },
  {
    "numero": 190,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Gexam, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "616-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1gW8axS9PVn7lll2NnnyPj8HX8cfQkgNa/view?usp=share_link"
  },
  {
    "numero": 191,
    "nivel": "Estatal",
    "proveedorContratista": "Torres y Straffon, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "635-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1SB-E6l0oRUUmmmukvKv0nuLAFAm60trq/view?usp=share_link"
  },
  {
    "numero": 192,
    "nivel": "Estatal",
    "proveedorContratista": "Bvi Consultores y Asesores, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "107-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1S9USgpFnsIcya1VObFj1rV023f_c-wJY/view?usp=share_link"
  },
  {
    "numero": 193,
    "nivel": "Estatal",
    "proveedorContratista": "Jemp Corporativo, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "116-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1s4mySZIWJteT6RGXiTVsMg7HRcubhIT2/view?usp=share_link"
  },
  {
    "numero": 194,
    "nivel": "Estatal",
    "proveedorContratista": "Soluciones Educativas Hernav, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "271-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1bIcNLVDd8uwc2S8fZBGA8p7ecwjb7X9U/view?usp=share_link"
  },
  {
    "numero": 195,
    "nivel": "Estatal",
    "proveedorContratista": "Jergui, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "376-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/17jdGZClWemSYjDvith2y7KiFAR5G1o_W/view?usp=share_link"
  },
  {
    "numero": 196,
    "nivel": "Estatal",
    "proveedorContratista": "Horeb Proyección, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "359-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1W7SRWL-B9USP0bFyZa7do9lv2_QO0xdu/view?usp=share_link"
  },
  {
    "numero": 197,
    "nivel": "Estatal",
    "proveedorContratista": "Fanto, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "378-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1ruH6KFhd813FnGbXUPvyTvWYNXPdpfcF/view?usp=share_link"
  },
  {
    "numero": 198,
    "nivel": "Estatal",
    "proveedorContratista": "Cuna Mayoristas, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "492-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1e0B5gXNhHt1bSnQb4z9psZ1Ebp3IWAzX/view?usp=share_link"
  },
  {
    "numero": 199,
    "nivel": "Estatal",
    "proveedorContratista": "Consorcio Reich Werden, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "634-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1oXIUGYC2fuBplqfkEfLw4JQKCSg5t1qZ/view?usp=share_link"
  },
  {
    "numero": 200,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Caprijaga, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "641-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1pY8ur7Bl6gkr_9Mb8Y2gO8O5TKUzhtPG/view?usp=share_link"
  },
  {
    "numero": 201,
    "nivel": "Estatal",
    "proveedorContratista": "Especialistas en Mantenimiento y Construcción Loga, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "643-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1rVxP69RkfTgcAXtadLbmL_I0mm3QNOCw/view?usp=share_link"
  },
  {
    "numero": 202,
    "nivel": "Estatal",
    "proveedorContratista": "Distribuidora y Comercializadora Lodiso, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "101-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1ee-d2Zfrjkfy2VhxKnrlT_ZTJfMPt-O_/view?usp=share_link"
  },
  {
    "numero": 203,
    "nivel": "Estatal",
    "proveedorContratista": "Delvillar Noticias, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "242-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1JZdS644amVTC9lMcfEkf6T-VVVWZFuTv/view?usp=share_link"
  },
  {
    "numero": 204,
    "nivel": "Estatal",
    "proveedorContratista": "Estructuras en Sistemas de Seguridad y Comunicaciones Esco, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "133-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1ZomEbsA-8j9Cc8yliRc7blF-MWqY0yYx/view?usp=share_link"
  },
  {
    "numero": 205,
    "nivel": "Estatal",
    "proveedorContratista": "Mex Alloy Ad, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "878-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1MzHJISVwUdncDnd-41FA-rlpakIa4F4z/view?usp=share_link"
  },
  {
    "numero": 206,
    "nivel": "Estatal",
    "proveedorContratista": "Agencia de Desarrollo Rural San Carlos, Sociedad Civil (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "434-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1jhmGVgpAMkd2bddl7_pT-u0p8sif1GRm/view?usp=share_link"
  },
  {
    "numero": 207,
    "nivel": "Estatal",
    "proveedorContratista": "Ártico Aire Acondicionado, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "502-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1VK-7JNDOjallTcgQ-VgafsxI33FLmcZR/view?usp=share_link"
  },
  {
    "numero": 208,
    "nivel": "Estatal",
    "proveedorContratista": "Sangre Nova Producciones, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "521-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1zbwu7nxQaiIC36aFWGAfFWAtt7gFNtkD/view?usp=share_link"
  },
  {
    "numero": 209,
    "nivel": "Estatal",
    "proveedorContratista": "Islas Group Suministros y Construcciones, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "527-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1_RTVu7sAGGtaktXIf9Dz-XDdZ1zzX048/view?usp=share_link"
  },
  {
    "numero": 210,
    "nivel": "Estatal",
    "proveedorContratista": "Oblk, Sociedad por Acciones Simplificada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "330-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1rkS39L2FhdzoXyTMRm7eZaHD-YtQ7QJN/view?usp=share_link"
  },
  {
    "numero": 211,
    "nivel": "Estatal",
    "proveedorContratista": "Proyecta Consultoría de Hidalgo, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "448-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1iJc-YWAuNRVoupUoPqJFyMdXanYj9AKF/view?usp=share_link"
  },
  {
    "numero": 212,
    "nivel": "Estatal",
    "proveedorContratista": "Viajes Apasear, Sociedad de Responsabilidad Limitada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "012-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/15xwTmCmpabwIpwby7cpXpk1wILLySvlV/view?usp=share_link"
  },
  {
    "numero": 213,
    "nivel": "Estatal",
    "proveedorContratista": "Ixtin Asistencia, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "060-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1S9FyEvoNl9wPGjCjBadGh3llpqYMNrNm/view?usp=share_link"
  },
  {
    "numero": 214,
    "nivel": "Estatal",
    "proveedorContratista": "Oublack Sociedad de Responsabilidad Limitada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "001-09-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1iiG3LJG8Wau3UkIrKuRcFiitVF-MMxRE/view?usp=share_link"
  },
  {
    "numero": 215,
    "nivel": "Estatal",
    "proveedorContratista": "José Gustavo Balcázar Vera (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "240-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/136XcOw4JJpJYbSd-juQILlk0MIjFgWNx/view?usp=share_link"
  },
  {
    "numero": 216,
    "nivel": "Estatal",
    "proveedorContratista": "Margarita Yahel Palacio Reyes (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "050-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1MeIVvoOecpkhVfKgK5UQR7KM7ARBwyg7/view?usp=share_link"
  },
  {
    "numero": 217,
    "nivel": "Estatal",
    "proveedorContratista": "Mayra Gallegos Garza (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "273-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1uoGf9ZHYLPWfrGd14yEJ_dqi6Lkl3Yor/view?usp=share_link"
  },
  {
    "numero": 218,
    "nivel": "Estatal",
    "proveedorContratista": "Oscar Ortíz Laguna (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "547-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1ns-AWlrm3NT-qcm5WwVCx7WwS3DQm5J-/view?usp=share_link"
  },
  {
    "numero": 219,
    "nivel": "Estatal",
    "proveedorContratista": "Maritza Sánchez Hernández (éROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "980-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1bX3K2GOaFfIFot6xM36P-3G9S-5g34eC/view?usp=share_link"
  },
  {
    "numero": 220,
    "nivel": "Estatal",
    "proveedorContratista": "Teresa Baños Ramos (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1137-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1DvYkWIRaAOIK7ZcRhr47RDd4uOI-Ufv2/view?usp=share_link"
  },
  {
    "numero": 221,
    "nivel": "Estatal",
    "proveedorContratista": "Jorge Aranda Hermosillo (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "139-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1G9kHObhOu9ScN9Pi5qS-XmZh_rbjcNQE/view?usp=share_link"
  },
  {
    "numero": 222,
    "nivel": "Estatal",
    "proveedorContratista": "Luis Alberto Ocadiz Cedeño (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "397-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1i_9bUwVcWP66gMKarpfuNJKlm2V3SZzr/view?usp=share_link"
  },
  {
    "numero": 223,
    "nivel": "Estatal",
    "proveedorContratista": "Juan de Dios Carlos Arteaga Castelán (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "437-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1UMD-fisU5me9TCNh__rRW3UMTJLuDaXN/view?usp=share_link"
  },
  {
    "numero": 224,
    "nivel": "Estatal",
    "proveedorContratista": "Juan Jesús Pacheco Luna (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "739-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/11C4om-zM2jk1tYCWEUWfILPWFmyiXH5J/view?usp=share_link"
  },
  {
    "numero": 225,
    "nivel": "Estatal",
    "proveedorContratista": "Claudia Aracely López Pérez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "768-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1q7Igfp0vjXm6G3v6Ab75UJmfamF_KWfj/view?usp=share_link"
  },
  {
    "numero": 226,
    "nivel": "Estatal",
    "proveedorContratista": "Construcciones y Supervisiones Forte, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "176-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/10m0JTc-EI2WQRwQUO_-hIdEELMcom-nW/view?usp=share_link"
  },
  {
    "numero": 227,
    "nivel": "Estatal",
    "proveedorContratista": "Cades Barnea, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "590-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1Fpr7XLVKXN1gpAl8WEOcbVn2dlrClMrU/view?usp=share_link"
  },
  {
    "numero": 228,
    "nivel": "Estatal",
    "proveedorContratista": "Instituto de Investigación y Difusión Jurídica, Sociedad Civil (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "604-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1iP1KNMFon9Jk0L4YnQ5m1AzsCkqQvmk1/view?usp=share_link"
  },
  {
    "numero": 229,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Solumedia, Sociedad de Responsabilidad Limitada Microindustrial (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "572-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1dJWu6Q2H-TPZiQDVOyr_bT5nLiLEDXdR/view?usp=share_link"
  },
  {
    "numero": 230,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora Exdecaf, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "777-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1rIwyJ6VX2p8fMquZOnuJJtL0ICfcfAp5/view?usp=share_link"
  },
  {
    "numero": 231,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Goal, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1090-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1DD4A-ZKbW6PuNsGD-OXQXZN4CdGQ1N-F/view?usp=share_link"
  },
  {
    "numero": 232,
    "nivel": "Estatal",
    "proveedorContratista": "Corpoaceros de Hidalgo, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1034-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1WEaCBf3_2uNzl-m_tN1vg57Ri1fANtlg/view?usp=share_link"
  },
  {
    "numero": 233,
    "nivel": "Estatal",
    "proveedorContratista": "Mahetzi Producciones, Sociedad de Responsabilidad Limitada Microindustrial (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1073-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1AFzpQoIs5PwdA1P3E6l_i6vkI7Yb9pLC/view?usp=share_link"
  },
  {
    "numero": 234,
    "nivel": "Estatal",
    "proveedorContratista": "Arqcor, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1170-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1brI9fwn76dfXwHCLmU_wiih5mA0_UZpf/view?usp=share_link"
  },
  {
    "numero": 235,
    "nivel": "Estatal",
    "proveedorContratista": "Servicios Integrales a la Microempresa Rural Servintemi, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1105-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1a3ezbgea_UT-nFinbX21Lq4biI-zH3M9/view?usp=share_link"
  },
  {
    "numero": 236,
    "nivel": "Estatal",
    "proveedorContratista": "Aktaion Digital, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "050-08-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1czBk0mA9Dk7MRHy4FVNdyWA-ngeKR3LY/view?usp=share_link"
  },
  {
    "numero": 237,
    "nivel": "Estatal",
    "proveedorContratista": "México Inolvidable, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "024-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1Jkwq96ITSc6r5MQBTpWFDUqv18tp1skq/view?usp=sharing"
  },
  {
    "numero": 238,
    "nivel": "Estatal",
    "proveedorContratista": "Comercializadora y Construcciones Ramírez León (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "214-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1QiplsjaoyduEIjXKZcSZ6ox6ABhJu_jy/view?usp=share_link"
  },
  {
    "numero": 239,
    "nivel": "Estatal",
    "proveedorContratista": "Operadores de Hoteles Pahuca, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "374-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1k2RAgansq8SgVIH1gouDL76y0__3Gj9A/view?usp=share_link"
  },
  {
    "numero": 240,
    "nivel": "Estatal",
    "proveedorContratista": "Cobertores y Blancos Marpel, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "395-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://drive.google.com/file/d/1-3PU1dj5FIS-igXyDw5srnuAYwHZS_Wa/view?usp=share_link"
  },
  {
    "numero": 241,
    "nivel": "Estatal",
    "proveedorContratista": "Nam Pachuca, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "386-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/NAM%20PACHUCA.pdf"
  },
  {
    "numero": 242,
    "nivel": "Estatal",
    "proveedorContratista": "Construcciones, Diseños y Supervisión Jade, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "487-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/CONSTRUCCIONES%20JADE.pdf"
  },
  {
    "numero": 243,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Santos del Golfo, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "003-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/GRUPO%20SANTOS.pdf"
  },
  {
    "numero": 244,
    "nivel": "Estatal",
    "proveedorContratista": "Trade-Ink, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "170-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/TRADE.pdf"
  },
  {
    "numero": 245,
    "nivel": "Estatal",
    "proveedorContratista": "LJ Mecánica Automotriz, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "552-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/JL%20MECANICA.pdf"
  },
  {
    "numero": 246,
    "nivel": "Estatal",
    "proveedorContratista": "Ciriaco Tomás Rodríguez Hernández",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "344-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/CIRIACO%20.pdf"
  },
  {
    "numero": 247,
    "nivel": "Estatal",
    "proveedorContratista": "Industrias Bimesxy, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "032-02-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/Industrias_bimesxy.pdf"
  },
  {
    "numero": 248,
    "nivel": "Estatal",
    "proveedorContratista": "Best Mexican Constructor, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "019-09-21",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/BEST%20MEXICAN.pdf"
  },
  {
    "numero": 249,
    "nivel": "Estatal",
    "proveedorContratista": "Hulyser, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "017-02-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/HUULYSER.pdf"
  },
  {
    "numero": 250,
    "nivel": "Estatal",
    "proveedorContratista": "Eco Suministros, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "197-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/eco_suministros.pdf"
  },
  {
    "numero": 251,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Rekkayy, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "045-02-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/grupo_rekkayy.pdf"
  },
  {
    "numero": 252,
    "nivel": "Estatal",
    "proveedorContratista": "Javier Arturo Aguilera Peña (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "376-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/javier_aguilera.pdf"
  },
  {
    "numero": 253,
    "nivel": "Estatal",
    "proveedorContratista": "Soluciones KMD, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "331-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/soluciones_kmd.pdf"
  },
  {
    "numero": 254,
    "nivel": "Estatal",
    "proveedorContratista": "TKM Interlogistic del Centro, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "537-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/tkm_interlogistic.pdf"
  },
  {
    "numero": 255,
    "nivel": "Estatal",
    "proveedorContratista": "Carla Ivón Plafox Palafox (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "029-05-21",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/carla_palafox.pdf"
  },
  {
    "numero": 256,
    "nivel": "Estatal",
    "proveedorContratista": "Corporativo para el Desarrollo de Negocios VAQPA, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "136-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/corporativo_vaqpa.pdf"
  },
  {
    "numero": 257,
    "nivel": "Estatal",
    "proveedorContratista": "Diseño y Desarrollo Alse, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "099-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/dise%C3%B1o_alse.pdf"
  },
  {
    "numero": 258,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Constructor Integral Cardavi, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "056-03-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/grupo_cardavi.pdf"
  },
  {
    "numero": 259,
    "nivel": "Estatal",
    "proveedorContratista": "Intraxis, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "248-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/intraxis_sociedad.pdf"
  },
  {
    "numero": 260,
    "nivel": "Estatal",
    "proveedorContratista": "Karla María Sánchez Chávez (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "1014-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/karla_maria.pdf"
  },
  {
    "numero": 261,
    "nivel": "Estatal",
    "proveedorContratista": "Mapa Dyne, Sociedad de Responsabilidad Limitada de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "043-11-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/mapa_dyne.pdf"
  },
  {
    "numero": 262,
    "nivel": "Estatal",
    "proveedorContratista": "Megamed, Sociedad Anónima de Capital Varaible (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "401-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/megamed_sociedad.pdf"
  },
  {
    "numero": 263,
    "nivel": "Estatal",
    "proveedorContratista": "Megaweb, Diseño de Software, Mantenimiento, Venta y Renta de Equipos de Cómputo, Consumibles y Equipo de Oficina, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "162-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/megaweb_sociedad.pdf"
  },
  {
    "numero": 264,
    "nivel": "Estatal",
    "proveedorContratista": "Movimedical, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "683-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/movimedical_sociedad.pdf"
  },
  {
    "numero": 265,
    "nivel": "Estatal",
    "proveedorContratista": "Remaco Servicios Empresariales, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "664-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/remaco_servicios.pdf"
  },
  {
    "numero": 266,
    "nivel": "Estatal",
    "proveedorContratista": "Team Xao, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "003-05-21",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/team_xao.pdf"
  },
  {
    "numero": 267,
    "nivel": "Estatal",
    "proveedorContratista": "Corporativo Jubai, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "013-04-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/corporativo_jubai.pdf"
  },
  {
    "numero": 268,
    "nivel": "Estatal",
    "proveedorContratista": "Consultoría Dwart, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "031-02-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/consultoria_dwart.pdf"
  },
  {
    "numero": 269,
    "nivel": "Estatal",
    "proveedorContratista": "Grupo Construc Cyrpo, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "041-03-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/grupo_cyrpo.pdf"
  },
  {
    "numero": 270,
    "nivel": "Estatal",
    "proveedorContratista": "Creaciones, Espectáculos y Producciones de México, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "025-08-20",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/creaciones_producciones.pdf"
  },
  {
    "numero": 271,
    "nivel": "Estatal",
    "proveedorContratista": "Producciones Autica, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "382-15",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/producciones_autica.pdf"
  },
  {
    "numero": 272,
    "nivel": "Estatal",
    "proveedorContratista": "Hugo Eduardo Ponce Morales (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "026-05-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/C%C3%89DULA%20Hugo%20Eduardo%20Ponce%20Morales.pdf"
  },
  {
    "numero": 273,
    "nivel": "Estatal",
    "proveedorContratista": "Input Output Company México, Sociedad Anónima de Capital Variable (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "003-05-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/C%C3%89DULA%20INPUT%20OUTPUT%20COMPANY%20MEXICO.pdf"
  },
  {
    "numero": 274,
    "nivel": "Estatal",
    "proveedorContratista": "Armando Roldán Pimentel(PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "505-16",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/CÉDULA Armando Roldán Pimentel.pdf"
  },
  {
    "numero": 275,
    "nivel": "Estatal",
    "proveedorContratista": "JOSÉ ENRIQUE PINEDA CARRASCO (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "568-18",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/568-18- JOSE ENRIQUE.pdf"
  },
  {
    "numero": 276,
    "nivel": "Estatal",
    "proveedorContratista": "VIOLETA BELÉN GONZÁLEZ TAPIA(PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "165-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/165-19-VIOLETA.pdf"
  },
  {
    "numero": 277,
    "nivel": "Estatal",
    "proveedorContratista": "Estatal SERVICIOS INMOBILIARIOS IROA, SOCIEDAD ANÓNIMA DE CAPITAL VARIABLE(PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "050-03-23",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/050-03-23- IROA.pdf"
  },
  {
    "numero": 278,
    "nivel": "Estatal",
    "proveedorContratista": "CONSORCIO HANDEL&BAUEN COMERCIO Y EDIFICACIÓN, SOCIEDAD ÁNONIMA DE CAPITAL VARIABLE (PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "032-19",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/032-19-HANDEL.pdf"
  },
  {
    "numero": 279,
    "nivel": "Estatal",
    "proveedorContratista": "COMERCIALIZADORA IDSART SOCIEDAD ANÓNIMA DE CAPITAL VARIABLE(PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "023-08-21",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/023-08-21-IDSAR.pdf"
  },
  {
    "numero": 280,
    "nivel": "Estatal",
    "proveedorContratista": "TRIPPRED TECHNOLOGIES, SOCIEDAD ANÓNIMA DE CAPITAL VARIABLE(PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "019-03-22",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/019-03-22- TRIPPRED.pdf"
  },
  {
    "numero": 281,
    "nivel": "Estatal",
    "proveedorContratista": "PONTONES & LEDESMA SOCIEDAD CIVIL(PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "008-10-21",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/008-10-21- PONTONES.pdf"
  },
  {
    "numero": 282,
    "nivel": "Estatal",
    "proveedorContratista": "ARGEL FERNANDO RODRÍGUEZ HERNÁNDEZ(PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "005-11-23",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/005-11-23-ARGEL.pdf"
  },
  {
    "numero": 283,
    "nivel": "Estatal",
    "proveedorContratista": "DRG IM PULZO, SOCIEDAD ANONIMA DE CAPITAL VARIABLE(PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "004-02-24",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/004-02-24- DGR IM.pdf"
  },
  {
    "numero": 284,
    "nivel": "Estatal",
    "proveedorContratista": "COMERCIALES TRISLER, SOCIEDAD ANONIMA DE CAPITAL VARIABLE(PROVEEDOR)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "003-02-24",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/003-02-24-TRISLER.pdf"
  },
  {
    "numero": 285,
    "nivel": "Estatal",
    "proveedorContratista": "Canes Grupo Constructor, S.A. de C.V. (Contratista)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "014-010-21",
    "sentidoResolucion": "Cancelación de registro por 6 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/014-010-21-CANES.pdf"
  },
  {
    "numero": 286,
    "nivel": "Estatal",
    "proveedorContratista": "Roclausa, S.A. de C.V. (Proveedor)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "702-17",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/702-17-roclausa.pdf"
  },
  {
    "numero": 287,
    "nivel": "Estatal",
    "proveedorContratista": "Constructora Cobalto, Sociedad Anónima de Capital Variable(Proveedor)",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "2970/9195",
    "sentidoResolucion": "Cancelación de registro por 6 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/Formato de Registros Cancelados_CONSTRUCTORA COBALTO SA DE CV.pdf"
  },
  {
    "numero": 288,
    "nivel": "Estatal",
    "proveedorContratista": "Rodolfo González González",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "030-11-20/1868",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/Formato de Registros Cancelados_RODOLFO GONZALEZ GONZALEZ.pdf"
  },
  {
    "numero": 289,
    "nivel": "Estatal",
    "proveedorContratista": "Isaac Factor Rios",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "012-02-21/5654",
    "sentidoResolucion": "Cancelación de registro por 6 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/Formato de Registros Cancelados_ISAAC FACTOR RIOS.pdf"
  },
  {
    "numero": 290,
    "nivel": "Estatal",
    "proveedorContratista": "Olga Pérez Zerón",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "437-15/162",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/Formato de Registros Cancelados_OLGA PEREZ ZERON.pdf"
  },
  {
    "numero": 291,
    "nivel": "Estatal",
    "proveedorContratista": "José Roberto Blanco Sánchez",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "021-03-22/2082",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/Formato de Registros Cancelados_JOSE ROBERTO BLANCO.pdf"
  },
  {
    "numero": 292,
    "nivel": "Estatal",
    "proveedorContratista": "David Zuñiga Hernandez",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "191-20/1734",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/Formato de Registros Cancelados_DAVID ZUÑIGA HERNANDEZ.pdf"
  },
  {
    "numero": 293,
    "nivel": "Estatal",
    "proveedorContratista": "José de Jeús Montiel Chávez",
    "institucionSancionadora": "Secretaría de Contraloría",
    "expediente": "3984-14/7424",
    "sentidoResolucion": "Cancelación de registro por 5 años",
    "pdfUrl": "https://s-contraloria.hidalgo.gob.mx/descargables/sancionados/Formato de Registros Cancelados_JOSE DE JESUS MONTIEL CHAVEZ.pdf"
  }
];
